import { app } from '../../app.module'
/**
 * 投稿一覧に表示するタグ一覧のディレクティブが呼び出された際に使用するサービス
 * @return {Object} オブジェクト
 */
function postTableTagListInit() {
  /**
   * parseTags タグの一覧が文字列になっているので、オブジェクトに変換する
   * @param tagsIdsStr 文字列になっているタグの一覧
   * @param tagsNamesStr 文字列になっているタグの一覧
   * @return tags オブジェクトの配列に整形したタグ一覧
   */
  function parseTags(tagsIdsStr: string, tagsNamesStr: string) {
    const tags = []
    // タグごとに区切り文字','で区切られているので、配列に戻す
    const TagIdsStrsArray: string[] = tagsIdsStr.split(',')
    const TagNamesStrsArray: string[] = tagsNamesStr.split(',')

    // タグごとに、オブジェクトに整形して、配列にプッシュする
    TagIdsStrsArray.forEach((elem: string, index: number) => {
      const tagObj: {
        tagId: string
        tagName: string
      } = {
        tagId: elem,
        tagName: TagNamesStrsArray[index],
      }

      if (tagObj.tagId !== null) {
        tags.push(tagObj)
      }
    })
    return tags
  }

  return {
    parseTags: parseTags,
  }
}

function postTableTagListService(postTableTagListInit) {
  return {
    Init: postTableTagListInit,
  }
}

app
  .factory('postTableTagListInit', postTableTagListInit)
  .factory('postTableTagListService', postTableTagListService)
